<template>
    <div class="box-summary w-100 mt-3">
        <div class="summary-card">
            <div class="summary-header d-flex justify-content-between align-items-center">
                <h4 class="summary-title">Tu Box</h4>
                <span class="summary-price">${{ price }}.00</span>
            </div>

            <div class="summary-items mt-2">
                <div class="summary-item d-flex align-items-center" v-for="(third, idx) in thirds" :key="idx">
                    <span class="summary-bullet">•</span>
                    <span class="summary-text">3 {{ products[third.product].name }} {{ third.variant === 'spicy' ? 'Spicy 🌶️' : 'Normal' }}</span>
                </div>
            </div>

            <button class="btn-add-cart w-100 mt-3" @click="addToCart">
                Agregar al Carrito
            </button>

            <button class="btn-start-over w-100 mt-2" @click="$emit('reset')">
                Empezar de nuevo
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BoxSummary',
    emits: ['reset'],
    props: {
        thirds: { type: Array, required: true },
        products: { type: Object, required: true },
        price: { type: Number, required: true },
    },
    methods: {
        addToCart() {
            // Pendiente integración con carrito
            alert('Box agregada al carrito (pendiente integración)');
        },
    },
};
</script>

<style scoped>
.summary-card {
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    border: 2px solid var(--primary);
    box-shadow: 0 4px 16px rgba(232, 118, 43, 0.15);
    animation: summaryAppear 0.4s ease;
}

@keyframes summaryAppear {
    0% { opacity: 0; transform: translateY(12px); }
    100% { opacity: 1; transform: translateY(0); }
}

.summary-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text3);
    margin: 0;
}

.summary-price {
    font-size: 22px;
    font-weight: 800;
    color: var(--primary);
}

.summary-item {
    padding: 4px 0;
}

.summary-bullet {
    color: var(--primary);
    font-size: 18px;
    margin-right: 8px;
    font-weight: 700;
}

.summary-text {
    font-size: 14px;
    color: var(--text6);
    font-weight: 500;
}

.btn-add-cart {
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-add-cart:hover {
    background: var(--vigequinary);
}

.btn-add-cart:active {
    transform: scale(0.98);
}

.btn-start-over {
    padding: 10px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: var(--text11);
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
}

.btn-start-over:hover {
    color: var(--primary);
}
</style>
